















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreteDistributionActivity,UpdateDistributionActivity,QueryMemberAllList,QueryPartnerAllList} from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'
import constant from '@/utils/constant'

@Component({
  components: {
    VTable,
    VImageUpload,
  },
})
export default class EditDistributionActivityDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.data = {
      memberIdList:[],
      partnerIdList:[],
    }
    this.show = false
  }
  private data: any = {
    memberIdList:[],
    partnerIdList:[]
  }
  private show = false
  private isEdit = false
  private typeList = constant.DistributionActivityType
  private memberList : Array<any> = []
  private partnerList : Array<any> = []

   public async created() {
    QueryMemberAllList().then(res=>{
      this.memberList = res
    })
    QueryPartnerAllList().then(res=>{
      this.partnerList = res
    })
  }


  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.data = {...this.data,...data}
    this.isEdit = isEdit
 
    if(this.data.memberIds){
      this.data.memberIdList = this.data.memberIds.split(",")
    }
    if(this.data.partnerIds){
      this.data.partnerIdList = this.data.partnerIds.split(",")
    }
  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    name: [this.requiredRule],
    totalNumber: [this.requiredRule],
    type: [this.requiredRule],
    startTime: [this.requiredRule],
    endTime: [this.requiredRule],
    distributionInterval: [this.requiredRule],
    numberType: [this.requiredRule],
    distributionTime: [this.requiredRule],

  }

  public handerChange(value: Array<any>){
    // this.data.memberIdList = value
    this.$set(this.data, 'memberIdList', value);

  }
  public handerPartnerChange(value: Array<any>){
    // this.data.memberIdList = value
    this.$set(this.data, 'partnerIdList', value);

  }

  public async save() {
    console.log(this.data);
    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        let result = {}
        if(this.isEdit){
          result = await UpdateDistributionActivity(this.data)
        } else {
          result = await CreteDistributionActivity(this.data)
        }
        if(result){
          this.close()
        }

      } else {
        this.$message.error("表单存在错误，不能保存")
        return false
      }
    })
  }
}
